import React, { PureComponent } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

type WebCardIconProps = {
  /* eslint react/no-unused-prop-types: "warn" */
  label?: string;
  className?: string;
  url?: string;
};

const Icon = styled.span({
  height: '24px',
  width: '24px',
  '&::before': {
    fontSize: '20px',
    marginLeft: '2px',
    marginTop: '-10px',
  },
});

class WebCardIcon extends PureComponent<WebCardIconProps> {
  render() {
    const { className, url } = this.props;

    if (url) {
      return <img src={url} alt={className} width="24" height="24" />;
    }

    const klass = ['aui-icon', 'aui-icon-large', className].join(' ').trim();
    return <Icon className={klass} />;
  }
}

export default WebCardIcon;
